import { GlobalFilterLocation, LocationFilterCategory } from 'src/types';

interface LocationFilterState {
  locationFilter: GlobalFilterLocation;
  locationFilterCategory: LocationFilterCategory;
  sites: string[];
  countries: string[];
  caseCountryCodes: string[];
  caseRegionIds: string[];
}

export const buildLocationQueryVariables = ({
  locationFilter,
  locationFilterCategory,
  sites,
  countries,
  caseCountryCodes,
  caseRegionIds,
}: LocationFilterState): Record<string, string[]> => {
  if (locationFilterCategory === LocationFilterCategory.CASE) {
    return { caseCountryCodes, caseRegionIds };
  } else if (locationFilter === GlobalFilterLocation.SITES) {
    return { sites };
  }

  return { countries };
};
